import { createSelector } from '@ngrx/store';
import { cryptoFeature } from './crypto.reducers';

export const selectCryptosLoading = createSelector(cryptoFeature.selectCryptosLoadingState, (loadingState) => loadingState === 'LOADING');
export const selectCryptosInitiallyLoaded = createSelector(
  cryptoFeature.selectCryptosLoadingState,
  (loadingState) => loadingState === 'LOADED',
);
export const selectPopularCryptos = createSelector(cryptoFeature.selectCryptos, (cryptos) =>
  cryptos.filter((crypto) => Boolean(crypto?.popular)),
);
export const selectETPsLoading = createSelector(cryptoFeature.selectEtpsLoadingState, (loadingState) => loadingState === 'LOADING');
export const selectETPsInitiallyLoaded = createSelector(cryptoFeature.selectEtpsLoadingState, (loadingState) => loadingState === 'LOADED');
export const selectEtpItems = createSelector(cryptoFeature.selectEtps, (etps) => etps.flatMap((etp) => etp.etps));
